import { AxiosInstance } from 'axios';
import { axiosFactory } from '../../../client';
import { S3FileIOPayLoadItems, RetrieveS3URLResponse } from './model';
import * as Routes from './routes';

const baseApiUrl = `${import.meta.env.VITE_APP_API_DOMAIN}/document`;
const timeout = 1000;

export const s3FileIOClient = axiosFactory(baseApiUrl, timeout);

export const s3FileIOTestClient = (s3FileIOClient as unknown) as AxiosInstance;

/** to Get S3 PreSign URL
 */
export const getRetrieveS3PreSignURL = (payload: S3FileIOPayLoadItems) =>
  s3FileIOClient.get<RetrieveS3URLResponse>(
    `${Routes.tS3FIleIORoute}${payload.url}/${payload.data}`
  );

/** to Get S3 PreSign URL
 */
export const getDocumentUploadStatus = (fileKey: string) =>
  s3FileIOClient.get<RetrieveS3URLResponse>(Routes.GET_FILE_UPLOAED_STATUS(fileKey));
